class ZGen {

  /**
   * 
   * @param {String} start 
   * @param {String} end 
   */
  static Alphabet(start = "A", end = "Z") {
    let rtn = [];
    let startC = start.charCodeAt(0);
    let lastC = end.charCodeAt(0);
    for (let i = startC; i <= lastC; ++i) {
      rtn.push(String.fromCharCode(i));
    }

    return rtn;
  }

  /**
   * 
   * @param {number} start 
   * @param {number} end 
   * @param {string} type lower
   * @returns array
   */
  static Number(start = 1, end = 10, type = "number") {
    let rtn = [];
    for (let i = start; i <= end; i++) {
      switch (type) {
        case "string":
          rtn.push(i.toString());
          break;
        case "number": default:
          rtn.push(i);
          break;
      }
    }
    return rtn;
  }

  /**
   * 
   * @param {Number} length 
   * @param {Number} bitmask 0b1111, [special, numbers, lowercase, uppercase]
   * @returns 
   */
  static Key(length = 0, bitmask = 0b1111){
    let uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let lowercase = "abcdefghijklmnopqrstuvwxyz";
    let numbers = "0123456789";
    let special  = "~!@#$%^&*(){}[],./?";
    let characters = "";
    if (bitmask & 1) {
      characters += uppercase;
    }      
    if (bitmask & 2) {
      characters += lowercase;
    }
    if (bitmask & 4) {
      characters += numbers;
    }
    if (bitmask & 8) {
      characters += special;
    }
    if (!characters) {
      characters = uppercase + lowercase;
    }
    let charactersLength = characters.length;
    let randomString = "";
    for (let i = 0; i < length; i++) {
      randomString += characters.charAt(Math.floor(Math.random() * (charactersLength - 1)));
    }
    return randomString;
  }
}

export default ZGen;